import {
  competitionListTimeEnum,
  MarketTypes,
  TabTypes,
} from "app/utils/const";
import store from "../store/store";
import type { EventType } from "../types/eventType";
export class RowHeightHelper {
  /**
   * sum up heights of components of an event for calculating the height of competition cells
   * @param {number} index
   * @returns number
   */
  static calculateEuroRowHeight: (index: any) => number = (index: any) => {
    // event height 56
    // market period header height 24
    // competition header height 24
    // alternative lines row of markets height 41
    const competition =
      store.getState().competitionListModel?.competitionList?.[index];
    const eventsViewType = store.getState().competitionsListFiltersModel?.type;
    const numberOfEvents = competition?.nbOfEvent ?? 0;
    const headerHeight = 24;
    const padding = 5;
    let eventHeight = 56;
    let altLinesHeight = 0;
    let showMoreLinkHeight = 24;

    const handleShowMoreLinkHeight = (eventsViewType: string): number => {
      if (eventsViewType === TabTypes.POPULAR && numberOfEvents > 5) {
        return showMoreLinkHeight;
      }
      return 0;
    };

    if (!competition || competition?.events.length === 0) {
      return 0;
    }

    // If competition is collapsed the cell is the height of the header
    if (competition?.isActive === false) {
      return headerHeight + padding;
    }

    competition &&
      competition.events &&
      competition.events.forEach(event => {
        if (event.alternativeMarketPeriods) {
          // calculate the height of the alternative lines section
          // to use to update the size of the comp cell
          event.alternativeMarketPeriods &&
            event.alternativeMarketPeriods.length > 0 &&
            event.alternativeMarketPeriods.forEach(amp => {
              const handicap = amp.marketTypes.find(marketType => {
                return marketType.marketType === MarketTypes.HANDICAP;
              });
              const total = amp.marketTypes.find(marketType => {
                return marketType.marketType === MarketTypes.TOTAL;
              });
              const outright = amp.marketTypes.find(marketType => {
                return marketType.marketType === MarketTypes.OUTRIGHT;
              });

              const numberOfHdpMarkets =
                (handicap && handicap.markets.length) || 0;
              const numberOfTotalMarkets = (total && total.markets.length) || 0;
              const numberOfOutrightRunners =
                (outright && outright.markets[0].runners?.length / 2 + 1) || 0;

              let highestTotal = Math.max(
                numberOfHdpMarkets,
                numberOfTotalMarkets,
                numberOfOutrightRunners
              );

              altLinesHeight += highestTotal * 42;
            });
          const numberOfAlternativeMarketPeriods =
            event.alternativeMarketPeriods &&
            event.alternativeMarketPeriods.length > 0
              ? event.alternativeMarketPeriods.length
              : 0;
          // add height for the header of eaxh market period
          altLinesHeight +=
            headerHeight * numberOfAlternativeMarketPeriods + 15;
        }

        //for padding
        altLinesHeight += 2;
      });

    return (
      competition.events.length * eventHeight +
      headerHeight +
      altLinesHeight +
      handleShowMoreLinkHeight(eventsViewType)
    );
  };

  static calculateAsianRowHeight: (index: any) => number = (index: any) => {
    const competition =
      store.getState().competitionListModel.competitionList[index];
    const line = store.getState().asianCompetitionListFiltersModel.line;
    const eventHeight = 57;
    const headerHeight = 24;
    let height = headerHeight;

    if (competition?.events.length === 0) {
      return 0;
    }

    // If competition is collapsed the cell is the height of the header
    if (competition?.isActive === false) {
      return headerHeight;
    }

    if (competition?.events.length > 0) {
      height = 0;

      // line type ALL Event cell heights are determined by the market column with the most markets
      if (line === competitionListTimeEnum.ALL) {
        competition.events.forEach(event => {
          if (event["numberOfMarkets"] > 0 && event.marketPeriods.length) {
            let noOf1X2Markets =
              event.marketPeriods[0].marketTypes[0].markets.length;
            let noOfHDPMarkets =
              event.marketPeriods[0].marketTypes[1].markets.length;
            let noOfTotalMarkets =
              event.marketPeriods[0].marketTypes[2].markets.length;
            let highestTotal = Math.max(
              noOfHDPMarkets,
              noOf1X2Markets,
              noOfTotalMarkets
            );
            height += highestTotal * 53 + 20;
          } else {
            height += eventHeight;
          }
        });
        return height + headerHeight;
      } else {
        competition.events.forEach(event => {
          if (
            event.marketPeriods &&
            event.marketPeriods[0]?.marketTypes[0]?.marketType ===
              MarketTypes.OUTRIGHT
          ) {
            event.marketPeriods[0]?.marketTypes.forEach(marketType => {
              const runnerLength = marketType.markets[0].runners?.length;
              const marketLength = runnerLength / 2 + 1;
              height += 38 * marketLength;
            });
          } else {
            height += eventHeight;
          }
        });
        return height + headerHeight;
      }
    }

    return height;
  };
  static calculateAllLinesEventHeight: (event: EventType) => number = (
    event: EventType
  ) => {
    const eventHeight = 57;
    const headerHeight = 24;
    let height = headerHeight;

    if (event["numberOfMarkets"] > 0 && event.marketPeriods.length) {
      let noOf1X2Markets = event.marketPeriods[0].marketTypes[0].markets.length;
      let noOfHDPMarkets = event.marketPeriods[0].marketTypes[1].markets.length;
      let noOfTotalMarkets =
        event.marketPeriods[0].marketTypes[2].markets.length;
      let highestTotal = Math.max(
        noOfHDPMarkets,
        noOf1X2Markets,
        noOfTotalMarkets
      );
      height += highestTotal * 53 + 20;
    } else {
      height += eventHeight;
    }

    return height + headerHeight;
  };
  /**
   * sum up heights of components of an event for calculating the height of competition cells
   * @param {number} index
   * @returns number
   */
  static calculateMobileRowHeight: (index: any) => number = (index: any) => {
    const competition =
      store.getState().competitionListModel.competitionList[index];
    const headerHeight = 24;
    const padding = 5;
    let eventHeight = 57;
    let competitionHeight = headerHeight + padding;

    if (competition?.isActive || competition?.isActive === undefined) {
      competition &&
        competition.events &&
        competition.events.forEach(event => {
          // Take into account if event expanded and what markets are showing
          if (event.isActive) {
            const favouriteHeight = 32;
            const marketHeight = 73;
            let expandedHeight = favouriteHeight;
            if (
              event.alternativeMarketPeriods &&
              event.alternativeMarketPeriods[0].marketTypes[0]?.marketType ===
                MarketTypes.OUTRIGHT
            ) {
              event.alternativeMarketPeriods[0]?.marketTypes.forEach(
                marketType => {
                  const runnerLength = marketType.markets[0].runners?.length;
                  const marketLength = runnerLength / 2 + 1;
                  expandedHeight += marketHeight * marketLength;
                }
              );
            } else {
              event?.marketPeriods?.[0]?.marketTypes?.forEach(marketType => {
                const hasRunners = marketType.markets[0].runners?.length;
                if (hasRunners) {
                  expandedHeight += marketHeight;
                }
              });
            }
            competitionHeight += expandedHeight;
          }
          competitionHeight += eventHeight;
        });
    }

    return competitionHeight;
  };
}
